import { Button } from "@mui/material";
import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";

const FileInput = forwardRef(
  (
    {
      fileType,
      fileEntry,
      existingFile,
      onChange,
      number,
      isOwnerPassportFile,
    },
    ref
  ) => {
    const [selectedFile, setSelectedFile] = useState(existingFile || null);

    useEffect(() => {
      setSelectedFile(existingFile);
    }, [existingFile]);

    useImperativeHandle(ref, () => ({
      checkFileError: () => {
        // console.log("Checking file error:", !selectedFile);
        return !selectedFile;
      },
      // updateFile: (newFile) => {
      //   console.log("Updating file:", newFile);
      //   setSelectedFile(newFile);
      // },
    }));

    // const handleFileChange = (event) => {
    //   const file = event.target?.files[0];

    //   if (file?.length !== 0) {
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //       const fileExtension = file.name.split(".").pop();
    //       const newFile = {
    //         id: existingFile ? existingFile.id : 0,
    //         fileName: fileEntry,
    //         file: reader.result,
    //         fileExtension: `.${fileExtension}`,
    //         isOwnerPassport: isOwnerPassportFile,
    //       };
    //       setSelectedFile(newFile);
    //       ref.current.updateFile(newFile); 
    //       onChange(newFile);
    //     };
    //     if (file) {
    //       reader.readAsDataURL(file);
    //     }
    //   } else {
    //     ref.current.updateFile(null); 
    //     onChange(null);
    //   }
    // };

    const handleFileChange = (event) => {
      const file = event.target?.files[0];

      if (file?.length!== 0) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const fileExtension = file.name.split('.').pop();
          const newFile = {
            id: existingFile ? existingFile.id : 0,
            fileName: fileEntry,
            file: reader.result,
            fileExtension: `.${fileExtension}`,
            isOwnerPassport: isOwnerPassportFile,
          };

          setSelectedFile(newFile);
          onChange(newFile);
        };
        if (file){
          reader.readAsDataURL(file);
        }
      } else {
        setSelectedFile(null);
        onChange(null);
      }
    };

    const handleButtonClick = () => {
      document.getElementById(`fileInput_${fileEntry}`).click();
    };

    return (
      <div>
        <p>
          {number}. {fileType}
        </p>
        {selectedFile ? (
          <div style={{ marginTop: "1rem" }}>
            <img
              src={selectedFile.file}
              alt={fileEntry}
              style={{ maxWidth: "100px", maxHeight: "100px" }}
            />
          </div>
        ) : null}
        <input
          type="file"
          onChange={handleFileChange}
          id={`fileInput_${fileEntry}`}
          style={{ display: "none" }}
        />
        <Button
          variant="outlined"
          component="label"
          sx={{ maxWidth: "fit-content", margin: "1rem 0 1.5rem 0" }}
          startIcon={<UploadFileRoundedIcon sx={{ color: "#137542" }} />}
          onClick={handleButtonClick}
        >
          Upload {fileEntry}
        </Button>
      </div>
    );
  }
);

export default FileInput;
